import trackUserActivity from "./trackUserActivity.js";
import { UserActivityEvent } from "./types.js";
const trackPageView = ({ type, id, page, user, pageData })=>{
    trackUserActivity({
        event: UserActivityEvent.PAGE_VIEW,
        data: {
            item_id: id,
            item_type: type,
            path: window.location.href.split('?')[0],
            origin_path: window.document.referrer.split('?')[0],
            page_identifier: page,
            page_data: pageData
        },
        user: user ? {
            segment: user.segmentationKey,
            username: user.username
        } : void 0
    });
};
const UserActivity_trackPageView = trackPageView;
export default UserActivity_trackPageView;
